import {
  LottoCardFlagHeaderProps,
  LottoCardFlagHeaderVariant,
} from './LottoCardFlagHeader.types'

const variantStyles: Record<
  LottoCardFlagHeaderVariant,
  { wrapper: string; title: string; titleAs: 'h3' | 'div' }
> = {
  normal: {
    wrapper: 'mb-2',
    title: 'font-bold text-lg text-left text-[var(--lotto-card-title-text)]',
    titleAs: 'h3',
  },
  yeekee: {
    wrapper: '',
    title:
      'font-bold text-lg text-left whitespace-nowrap text-[var(--yeekee-title-color)]',
    titleAs: 'h3',
  },
  thai: {
    wrapper: 'mb-1 md:mb-2',
    title:
      'font-bold text-xl md:text-3xl text-left text-[var(--lotto-card-title-text)]',
    titleAs: 'div',
  },
}

const LottoCardFlagHeader: React.FC<LottoCardFlagHeaderProps> = ({
  title,
  country,
  imageMap,
  variant = 'normal',
}) => {
  const {
    wrapper,
    title: titleClass,
    titleAs: TitleTag,
  } = variantStyles[variant]

  return (
    <div className={`flex items-center justify-between ${wrapper}`}>
      <TitleTag className={titleClass}>{title}</TitleTag>
      <img
        src={imageMap[country]}
        alt={`${country} flag`}
        className="w-12 h-12 rounded-full border-2 border-[var(--flag-white-border)] object-cover"
      />
    </div>
  )
}

export default LottoCardFlagHeader
